import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Select, styled } from '@nextiva/next-ui-components';
import classes from './GreetingActions.scss';

const StyledSelect = styled(Select)`
  display: ${({ actionsOpen }) => (actionsOpen ? 'inline-block' : 'none')};
  width: 98px;
  height: 38px;
  & .MuiSelect-select span {
    color: ${({ theme }) => theme.palette.blueGrey.A400};
    margin-right: 2px;
  }
`;
const linksConst = {
  SET_AS_GREETING: 'SET_AS_GREETING',
  DELETE: 'DELETE',
};

const GreetingActions = (props) => {
  const [actionsOpen, setActionsOpen] = useState(false);

  const handleSelectChange = (e) => {
    if (e.target.value === linksConst.SET_AS_GREETING) {
      props.onSetUserGreeting(props.greeting);
    }

    if (e.target.value === linksConst.DELETE) {
      props.onDeleteUserGreeting(props.greeting);
    }
  };

  const getOptions = () => {
    const options = [];

    if (!props.isAssignedGreeting) {
      options.push({
        label: 'Set as greeting',
        value: linksConst.SET_AS_GREETING,
        className: classes.default,
      });
    }

    if (!props.isDefaultGreeting) {
      options.push({
        label: 'Delete greeting',
        value: linksConst.DELETE,
        className: classes.delete,
      });
    }

    return options;
  };

  return (
    <StyledSelect
      id="Greeting selectID"
      placeholder="Actions"
      defaultValue="Actions"
      value=""
      open={actionsOpen}
      onChange={handleSelectChange}
      onOpen={() => setActionsOpen(true)}
      onClose={() => setActionsOpen(false)}
      actionsOpen={actionsOpen}
      data-testid="PlatformAdminUI-GreetingActions-Select"
      className="actionSelect--selector"
    >
      {getOptions().map((option) => (
        <MenuItem
          key={option.greetingName}
          value={option.value}
          className={option.className}
        >
          {option.label}
        </MenuItem>
      ))}
    </StyledSelect>
  );
};

GreetingActions.propTypes = {
  greeting: PropTypes.shape({
    greetingName: PropTypes.string.isRequired,
    greetingType: PropTypes.string.isRequired,
  }).isRequired,
  isAssignedGreeting: PropTypes.bool.isRequired,
  isDefaultGreeting: PropTypes.bool.isRequired,
  onDeleteUserGreeting: PropTypes.func.isRequired,
  onSetUserGreeting: PropTypes.func.isRequired,
};
GreetingActions.displayName = 'GreetingActions';

export default GreetingActions;
